








































import Vue, { PropType } from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import SyncStatusBadge from "../SyncStatusBadge.vue";
import DateTimeDisplay from "@/components/DateTimeDisplay.vue";
import CarInfo from "../detailViews/CarInfo.vue";
import IfaceSyncCar from "../../models/IfaceSyncCar";
import { Iface } from "../../models/Iface";
import store from "../../services/InterfaceStore";

/**
 * Egy gépjármű szinkron sorának (interfész + külső azonosító) összes köztes tábla sora, újabb → régebbi
 * sorrendben — a PartnerHistory mintájára. Gépjárműhöz nincs részletes szerkesztő, ezért nincs parancs-oszlop.
 */
interface Props {
  /** Csoportosító külső azonosító (a search-en ezt használja) */
  extCode: string;
  /** Az aktuális gépjármű rekord */
  car: IfaceSyncCar | null;
}

interface Computed {
  verkCarId: number;
  url: string;
  apiSearchName: string;
  columns: any[];
}

export default Vue.extend<{}, {}, Computed, Props>({
  name: "CarHistory",

  components: {
    ApiSearchPage,
    SyncStatusBadge,
    DateTimeDisplay,
    CarInfo,
  },

  props: {
    extCode: { type: String, default: "" },
    car: { type: Object as PropType<IfaceSyncCar | null>, default: null },
  },

  computed: {
    /** Verk (felfelé irány): a külső kód a felküldésig üres, ezért ott a belső gépjármű azonosító (mmsercar.szam) a kulcs (0 = nem az) */
    verkCarId(): number {
      return store.selectedInterface === Iface.Verk && this.car && this.car.car > 1 ? this.car.car : 0;
    },

    url(): string {
      return this.verkCarId > 0
        ? `iface-sync-car/history-search-car/${store.selectedInterface}/${this.verkCarId}`
        : `iface-sync-car/history-search/${store.selectedInterface}/${encodeURIComponent(this.extCode)}`;
    },

    apiSearchName(): string {
      return this.verkCarId > 0 ? `CarHistoryApiSearch_car_${this.verkCarId}` : `CarHistoryApiSearch_${this.extCode}`;
    },

    columns(): any[] {
      return [
        { field: "updDateTime", title: "Időpont", width: 110, filterable: false, cell: "updDateTime" },
        { field: "syncStatusName", title: "Státusz", width: 140, cell: "syncStatusName" },
        { field: "car", title: "Belső azonosító", width: 100, cell: "disabledText" },
        { field: "bodyNo", title: "Alvázszám", width: 170, cell: "disabledText" },
        { field: "regNum", title: "Rendszám", width: 100, cell: "disabledText" },
        { field: "brand", title: "Márka", width: 100, cell: "disabledText" },
        { field: "modell", title: "Modell", cell: "disabledText" },
        { field: "owner", title: "Tulajdonos kód", width: 110, cell: "disabledText" },
        { field: "errorText", title: "Hibaüzenet", width: 200, cell: "disabledText" },
        { field: "syncRemark", title: "Megjegyzés", width: 180, cell: "disabledText" },
        { field: "updUserName", title: "Módosította", width: 130, cell: "disabledText" },
      ];
    },
  },
});
